<template>
  <v-card
    style="margin-top:25px; min-width: 305px;"
  >
    <v-card-text id="accountIconContainer"><i id="accountIcon" class="material-icons" >account_circle</i></v-card-text>
    <v-card-text>You need to sign in...</v-card-text>
    <v-flex xs12 style="padding:0 10px 0 10px">
      <v-text-field
        label="Username"
        outlined
        v-model="username"
        v-on:keyup.enter="onEnter"
      >
      </v-text-field>
      <v-text-field
        label="Password"
        outlined
        type="password"
        v-model="password"
        v-on:keyup.enter="onEnter"
      >
      </v-text-field>
      <div style="width:100%;color:blue;font-size:smaller;text-align:center;" @click="forgotPassword">request password reset</div>
    </v-flex>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn text @click="login">LOGIN</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'RequestPasswordResetForm',

  data() {
    return {
      form: {
        username: '',
        password: '',
      },
    };
  },

  computed: {
    username: {
      get() {
        return this.form.username;
      },
      set(value) {
        this.form.username = value;
        this.$emit('usernameChanged', this.form.username);
      },
    },

    password: {
      get() {
        return this.form.password;
      },
      set(value) {
        this.form.password = value;
        this.$emit('passwordChanged', this.form.password);
      },
    },
  },

  methods: {
    onEnter() {
      this.login();
    },

    forgotPassword() {
      console.log('user forgot their password');
      this.$router.replace('/request_password_reset');
    },
  },

  props: {
    login: Function,
  },
};
</script>

<style scoped>
/* Sets background hero image */
.heroDash {

  width: 100%;
  height: 100%;
}
#accountIconContainer {
  text-align: center !important;
  background-color: #42A5F5;
}

#accountIcon {
  color: black;
  font-size: 128pt;
}

</style>
